import { render, staticRenderFns } from "./MyClassesHub.vue?vue&type=template&id=4a4c63fa"
import script from "./MyClassesHub.vue?vue&type=script&lang=js"
export * from "./MyClassesHub.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a4c63fa')) {
      api.createRecord('4a4c63fa', component.options)
    } else {
      api.reload('4a4c63fa', component.options)
    }
    module.hot.accept("./MyClassesHub.vue?vue&type=template&id=4a4c63fa", function () {
      api.rerender('4a4c63fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/teacher/MyClassesHub.vue"
export default component.exports